// Adjust popover so it doesn't go off-screen on mobile
(function () {
    if (window._swatchesInit) return;
    window._swatchesInit = true;
  
    function adj(pop) {
      requestAnimationFrame(function () {
        pop.classList.remove('is-edge-left');
        pop.classList.remove('is-edge-right');
        var r = pop.getBoundingClientRect();
        var pad = 8;
        if (r.left < pad) pop.classList.add('is-edge-left');
        if (r.right > (window.innerWidth - pad)) pop.classList.add('is-edge-right');
      });
    }
  
    function init() {
      var swatches = document.querySelectorAll('.swatch');
  
      for (var i = 0; i < swatches.length; i++) {
        (function (s) {
          var pop = s.querySelector('.swatch__popover');
          if (!pop) return;
          function h() { adj(pop); }
          s.addEventListener('pointerenter', h);
          s.addEventListener('focusin', h);
        })(swatches[i]);
      }
  
      window.addEventListener('resize', function () {
        for (var i = 0; i < swatches.length; i++) {
          var p = swatches[i].querySelector('.swatch__popover');
          if (p) adj(p);
        }
      });
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();